import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/imgs/loading.svg")